import React from 'react'
import { useTranslation } from 'react-i18next'
import { FiCopy, FiCornerUpRight, FiEdit2, FiPlus } from 'react-icons/fi'
import {
  ErrorBar,
  LimitGird,
  LimitItem,
  PremiumTimer,
} from '../../components/PremiumLimitModal'
import Button from '../../components/Template/Button'
import PremiumModal from '../../components/PremiumModal'
import { CredentialsStorage } from '../../database/localStorage/names'
import { driver } from '../../database/localStorage'
import { getPanelUrlForEnv } from '../../utils/ApiUrl'

function mapLabelToIcon(label: string) {
  if (label === 'z677_adding_reservations') return <FiPlus size={20} />
  if (label === 'info_premium_edit_reservations') return <FiEdit2 size={20} />
  if (label === 'z677_copying_reservations') return <FiCopy size={20} />
  if (label === 'z677_moving_reservations') return <FiCornerUpRight size={20} />
}

function redirect() {
  const key = driver.getItem(CredentialsStorage.AccessToken, '')
  //var EnvUrl = getApiUrlForEnv()
  window.open(
    `${getPanelUrlForEnv()}/index/login?autologinkey=${key}&redirect=/payment`,
    '_blank',
  )
}

function PremiumLimitModal({
  open,
  limits,
  timeToReset,
  togglePremiumInfoModal,
  close,
}: IPremiumLimitModalProps & IPremiumLimitModalDispatch) {
  const { t } = useTranslation()

  function openInfoModal() {
    close()
    togglePremiumInfoModal()
  }

  const LimitsItems = limits.map(limit => (
    <LimitItem
      label={t(limit.type)}
      icon={mapLabelToIcon(limit.type)}
      state={limit.state}
      limit={limit.limit}
    />
  ))

  const buttons = () => (
    <>
      <Button style={{ width: '100%' }} onClick={openInfoModal}>
        {t('reservation_history_empty_btn')}
      </Button>
      <Button style={{ width: '100%' }} primary={true} onClick={redirect}>
        {t('payment_activity')}
      </Button>
    </>
  )

  return (
    <PremiumModal open={open} close={close} buttons={buttons()}>
      <ErrorBar />

      <PremiumTimer countTo={timeToReset} />

      <LimitGird>{LimitsItems}</LimitGird>
    </PremiumModal>
  )
}

export default PremiumLimitModal

export interface IPremiumLimitModalProps {
  open?: boolean
  limits?: {
    type: string
    state: number
    limit: number
    exceeded: boolean
  }[]
  timeToReset?: Date
}

export interface IPremiumLimitModalDispatch {
  close?: () => void
  togglePremiumInfoModal: () => void
}
